export const CHANGE_BEST_SELLING_FIELD = 'CHANGE_BEST_SELLING_FIELD';
export const GET_SETTING_BEST_SELLING = 'GET_SETTING_BEST_SELLING';
export const GET_SETTING_BEST_SELLING_RESULT = 'GET_SETTING_BEST_SELLING_RESULT';
export const SAVE_SETTING_BEST_SELLING = 'SAVE_SETTING_BEST_SELLING';
export const SAVE_SETTING_BEST_SELLING_RESULT = 'SAVE_SETTING_BEST_SELLING_RESULT';
export const CLEAR_DATA_BEST_SELLING = 'CLEAR_DATA_BEST_SELLING';
export const GET_LIST_PRODUCTS_DETAIL_BEST_SELLING_RESULT =
  'GET_LIST_PRODUCTS_DETAIL_BEST_SELLING_RESULT';
export const GET_LIST_PRODUCTS_DETAIL_BEST_SELLING = 'GET_LIST_PRODUCTS_DETAIL_BEST_SELLING';
export const ADD_PRODUCT_BEST_SELLING = 'ADD_PRODUCT_BEST_SELLING';
export const REMOVE_PRODUCT_BEST_SELLING = 'REMOVE_PRODUCT_BEST_SELLING';
export const CHANGE_BEST_SELLING_THEME = 'CHANGE_BEST_SELLING_THEME';
export const CHANGE_BEST_SELLING_SETTINGS = 'CHANGE_BEST_SELLING_SETTINGS';
